import { render } from "./copyTraders.vue?vue&type=template&id=02c5ab92"
import script from "./copyTraders.vue?vue&type=script&lang=js"
export * from "./copyTraders.vue?vue&type=script&lang=js"

import "./copyTraders.vue?vue&type=style&index=0&id=02c5ab92&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__